import React from 'react'
import { PreviewComp } from './PreviewComp'

interface StepFourProps {
  goToStep: (step: number) => void
}

export const StepFourComp = ({ goToStep }: StepFourProps) => {
  return (
    <div className='form-step'>
      <PreviewComp goToStep={goToStep} />
    </div>
  )
}
